var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandRenault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M28 32h64.703v56.693H28z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 0h121v121H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.972 83.26c0 .636-.442 1.105-1.264 1.105h-2.611v-2.208h2.611c.822 0 1.264.468 1.264 1.104zm2.423 5.31-1.704-2.93c.935-.458 1.427-1.326 1.427-2.38 0-1.571-1.096-2.732-3.127-2.732H28v8.042h2.097v-2.577h2.6l1.394 2.577h2.304zm27.197-3.131-1.361-3.256-1.362 3.256h2.723zm.684 1.636h-4.09l-.625 1.495H57.41l3.463-8.042h2.715l3.463 8.042h-2.15l-.625-1.495zm7.862 1.619c2.364 0 4.147-1.012 4.147-3.432v-4.734h-2.109v4.734c0 .816-.301 1.777-2.038 1.777-1.737 0-2.038-.961-2.038-1.777v-4.734h-2.11v4.734c0 2.42 1.784 3.432 4.148 3.432zm-17.992-8.166v5.282l-4.794-5.282h-1.781v8.042h1.88v-5.284l4.758 5.284h1.807v-8.042h-1.87zm-13.652 4.75h4.351v-1.544h-4.351v-1.571h4.762v-1.635h-6.853v8.042h6.984v-1.638h-4.893v-1.654zm40.249-4.75h-2.09v8.042H85.3v-1.638h-4.557v-6.404zm11.96 0v1.634h-3.102v6.408h-2.092v-6.408h-3.101v-1.634h8.295zM64.195 32h-3.089L50.291 52.219l6.952 13 1.545-2.89-5.407-10.11 9.27-17.331 9.268 17.33-10.813 20.22h3.089l10.814-20.22L64.195 32zm4.635 20.219-10.814 20.22h-3.089l-10.814-20.22 10.814-20.22h3.089L47.201 52.22l9.271 17.332 9.269-17.332-5.408-10.11 1.545-2.89 6.952 13z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandRenault);
export default __webpack_public_path__ + "static/media/brand_renault.80ea652b513f486cc9d47f77f7be1a95.svg";
export { ForwardRef as ReactComponent };